module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('pop', {
    attrs: {
      "display": _vm.popDisplay,
      "title": "提示",
      "msg": _vm.popMsg,
      "onlyOk": _vm.popOnlyOk
    },
    on: {
      "closeHandler": _vm.closePop,
      "okHandler": _vm.CancelBreakfast
    }
  }), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.hintMsg,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing,
      "trigger": _vm.trigger
    },
    on: {
      "refresh": _vm.refresh
    }
  }), _vm._v(" "), _c('pageTitle', {
    attrs: {
      "title": "早餐券"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#F5F5F5",
      "min-height": "12.4rem"
    }
  }, [_c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "0",
      "title": "进行中的订单"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "1",
      "title": "历史订单"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.2rem"
    }
  }), _vm._v(" "), _vm._l((["0", "1", "2"]), function(ListName, index) {
    return _c('div', _vm._l((_vm.BreakfastList[_vm.activeTab]), function(item, index) {
      return (ListName == _vm.activeTab) ? _c('div', [_c('div', {
        staticStyle: {
          "background-color": "#fff",
          "width": "6.9rem",
          "margin": "0  0.3rem"
        }
      }, [_c('div', {
        staticStyle: {
          "font-size": "0.24rem",
          "color": "#999",
          "padding": "0 0.35rem",
          "line-height": "0.8rem",
          "border-bottom": "1px solid #F4F4F5"
        }
      }, [_vm._v("\n            订单号：" + _vm._s(item.breakfastResvNo) + "\n          ")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "0.3rem",
          "color": "#000",
          "font-weight": "bold",
          "padding": "0.25rem 0.35rem"
        }
      }, [_vm._v("\n            " + _vm._s(item.HotelName) + "\n          ")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "0.24rem",
          "color": "#999",
          "line-height": "0.36rem",
          "padding": "0 0.35rem"
        }
      }, [_c('div', {
        staticStyle: {}
      }, [_vm._v(" 购买时间： " + _vm._s(item.createtimeText) + " ")]), _vm._v(" "), _c('div', {
        staticStyle: {}
      }, [_vm._v(" 有效日期： " + _vm._s(item.StartTimeText) + " 至 " + _vm._s(item.EndTimeText) + " ")]), _vm._v(" "), _c('div', {
        staticStyle: {}
      }, [_vm._v("\n              金\n              "), _c('span', {
        staticStyle: {
          "color": "white"
        }
      }, [_vm._v("金额")]), _vm._v("额：￥" + _vm._s(item.AAListBag[0].paymoney) + " × " + _vm._s(item.countPerDay) + "张 × " + _vm._s(item.CostDays) + "天\n            ")])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "height": "0.2rem",
          "margin": "0  0.35rem",
          "border-bottom": "1px solid #F4F4F5"
        }
      }), _vm._v(" "), (ListName == 0) ? _c('div', {
        staticStyle: {
          "overflow": "hidden",
          "height": "1.05rem",
          "padding": "0.25rem 0.35rem"
        }
      }, [_c('div', {
        staticStyle: {
          "float": "left",
          "font-size": "0.26rem",
          "color": "#666",
          "padding": "0.1rem 0"
        }
      }, [_vm._v("\n              合计：\n              "), _c('span', {
        staticStyle: {
          "font-weight": "bold",
          "color": "#27ba69",
          "font-size": "0.24rem",
          "height": "0.1rem"
        }
      }, [_vm._v("\n                ￥\n                "), _c('span', {
        staticStyle: {
          "font-size": "0.3rem"
        }
      }, [_vm._v(_vm._s(_vm._f("KeepTwoNum")(item.countPerDay * item.CostDays * item.AAListBag[0].paymoney)) + " ")])])]), _vm._v(" "), (item.AAListBag[0].ticketNo == '') ? _c('div', {
        staticClass: "opBtn payBtn",
        staticStyle: {
          "color": "#ffa135",
          "border": "1px solid #ffa135"
        },
        on: {
          "click": function($event) {
            return _vm.GoPay(item)
          }
        }
      }, [_vm._v("\n              去支付\n            ")]) : _c('div', {
        staticClass: "opBtn payBtn",
        on: {
          "click": function($event) {
            return _vm.LookDetails(item)
          }
        }
      }, [_vm._v("\n              查看订单\n            ")]), _vm._v(" "), _c('div', {
        staticClass: "opBtn",
        on: {
          "click": function($event) {
            return _vm.openPop(item.breakfastResvNo, item.AAListBag[0].ticketNo)
          }
        }
      }, [_vm._v("\n              取消订单\n            ")])]) : _vm._e(), _vm._v(" "), (ListName == 1) ? _c('div', {
        staticStyle: {
          "overflow": "hidden",
          "height": "1rem",
          "padding": "0.25rem 0.35rem"
        }
      }, [_c('div', {
        staticStyle: {
          "float": "left",
          "font-size": "0.26rem",
          "color": "#666",
          "padding": "0.1rem 0"
        }
      }, [_vm._v("\n              合计：\n              "), _c('span', {
        staticStyle: {
          "font-weight": "bold",
          "color": "#27ba69",
          "font-size": "0.24rem",
          "height": "0.1rem"
        }
      }, [_vm._v("\n                ￥\n                "), _c('span', {
        staticStyle: {
          "font-size": "0.3rem"
        }
      }, [_vm._v(_vm._s(_vm._f("KeepTwoNum")(item.countPerDay * item.CostDays * item.AAListBag[0].paymoney)) + " ")])])]), _vm._v(" "), (item.AAListBag[0].ticketNo != '') ? _c('div', {
        staticClass: "opBtn payBtn",
        on: {
          "click": function($event) {
            return _vm.LookDetails(item)
          }
        }
      }, [_vm._v("\n              查看订单\n            ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "height": "0.2rem"
        }
      })]) : _vm._e()
    }), 0)
  }), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "您目前没有早餐券哦！",
      "mainIcon": "noVoucher",
      "noMore": _vm.loadState[this.activeTab].stop,
      "isLoading": _vm.loadState[this.activeTab].loading,
      "overZero": _vm.BreakfastList[_vm.activeTab].length > 0
    }
  }), _vm._v(" "), (_vm.loadState[this.activeTab].loading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "0.2rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.2rem"
    },
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.1rem"
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d2cbacc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/Breakfast.vue
// module id = 1496
// module chunks = 18